import firedux from '../firedux'
import {dispatch} from '../store'

import {
  CONVERSATIONS_PRIVATE_REFS_ENDPOINT
} from '../../config/constants'

import setConversationRefs from '../actions/set_conversation_refs'

let ENDPOINT

const onConversationRefs = (snapshot) => {
  if (snapshot.exists()) dispatch(setConversationRefs(snapshot.val()))
}

export const watchConversations = (uid) => {
  ENDPOINT = `${CONVERSATIONS_PRIVATE_REFS_ENDPOINT}/${uid}`

  firedux.ref.child(ENDPOINT).on('value', onConversationRefs)
}

export const unwatchConversations = () => {
  if (!ENDPOINT) return

  firedux.ref.child(ENDPOINT).off('value', onConversationRefs)
}



/** WEBPACK FOOTER **
 ** ./modules/shared/data/watchers/conversations.js
 **/